import { EntityType } from '@nkr/enums/entity-type';

export interface IAllowDuplicateOverrideState {
    isAllowed: boolean
}

export interface IAllowDuplicateOverridePost {
    entityType: EntityType,
    profileId: number,
    reason: string
}
